import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import Alert from "@material-ui/lab/Alert";
import IconButton from "@material-ui/core/IconButton";
import Collapse from "@material-ui/core/Collapse";
import CloseIcon from "@material-ui/icons/Close";

const useStyles = makeStyles((theme) => ({
  root: {
    marginBottom: "15px",
    "& > * + *": {
      margin: theme.spacing(2),
    },
  },
}));

export default function TransitionAlerts({ errors, severity, open, setOpen }) {
  const classes = useStyles();

  return (
    errors.length !== 0 && (
      <div className={classes.root}>
        <Collapse in={open}>
          <Alert
            severity={severity}
            action={
              <IconButton
                aria-label="close"
                color="inherit"
                size="small"
                onClick={() => {
                  setOpen(false);
                }}
              >
                <CloseIcon fontSize="inherit" />
              </IconButton>
            }
          >
            {errors}{" "}
          </Alert>
        </Collapse>
      </div>
    )
  );
}
